import React from 'react';

const OrderOnlinePage = () => {
    return (
        <div>
            <h1>Order Online Page</h1>
            <p>Order your meal online.</p>
        </div>
    );
};


export default OrderOnlinePage;